{
  "auth.login.otp.phone.back.button_label": "Retour",
  "auth.login.otp.phone.form.continue.button_label": "Continuer",
  "auth.login.otp.phone.form.country_code.label": "Indicatif du pays",
  "auth.login.otp.phone.form.country_code.invalid_error": "Sélectionnez l’indicatif du pays.",
  "auth.login.otp.phone.form.phone_number.helper_text": "Nous vous enverrons un code pour confirmer votre numéro.",
  "auth.login.otp.phone.form.phone_number.label": "Numéro de téléphone",
  "auth.login.otp.phone.form.phone_number.placeholder": "Numéro de téléphone",
  "auth.login.otp.phone.form.phone_number.invalid_error": "Impossible d’envoyer un code à ce numéro de téléphone. Essayez d’en utiliser un autre ou connectez-vous avec votre adresse courriel.",
  "auth.login.otp.phone.passcode.form.label": "Code",
  "auth.login.otp.phone.passcode.form.placeholder": "Code",
  "auth.login.otp.phone.passcode.form.resend.link_text": "Vous n’avez pas reçu le SMS? Renvoyer le code",
  "auth.login.otp.phone.passcode.form.resend.link_text.resending": "Renvoi en cours...",
  "auth.login.otp.phone.passcode.form.switch_method.link_text": "Envoyer le code par courriel",
  "auth.login.otp.phone.passcode.helper_text": "Saisissez le code envoyé à"
}
